import { useState } from 'react'

import { Member, Space } from '@tribeplatform/gql-client/types'
import { Form } from '@tribeplatform/react-sdk/components'
import { Card } from '@tribeplatform/react-ui-kit/Card'
import { Container, GridList } from '@tribeplatform/react-ui-kit/Layout'

import { AuditLogList } from '../../AuditLog/AuditLogList'

export const AuditLogs = () => {
  const [space, setSpace] = useState<Space>()
  const [member, setMember] = useState<Member>()
  const [noun, setNoun] = useState('')

  return (
    <Container>
      <div className="px-2">
        <h3 className="mb-3">Audit log</h3>
        <Form onSubmit={null} defaultValues={{ noun: '', timeframe: '168' }}>
          <GridList columns={3} className="mb-5">
            <GridList.Item>
              <Form.MemberPicker
                name="member"
                label="Actor"
                value={member}
                placeholder="Select a member..."
                onChange={member => setMember(member)}
              />
            </GridList.Item>
            <GridList.Item>
              <Form.SpacePicker
                name="space"
                label="Space"
                value={space}
                placeholder="Select a space..."
                onChange={space => setSpace(space)}
              />
            </GridList.Item>
            <Form.Select
              name="noun"
              label="Action type"
              onChange={value => {
                setNoun(value)
              }}
              items={[
                { value: '', text: 'All types' },
                { value: 'SPACE', text: 'Space' },
                { value: 'POST', text: 'Post' },
                { value: 'MEMBER', text: 'Member' },
                { value: 'NETWORK', text: 'Community' },
                { value: 'COLLECTION', text: 'Collection' },
                { value: 'REACTION', text: 'Reaction' },
                { value: 'MODERATION', text: 'Moderation' },
                { value: 'MEMBER_INVITATION', text: 'Invitation' },
                { value: 'APP_INSTALLATION', text: 'App Installation' },
                { value: 'APP', text: 'App' },
                { value: 'SSO', text: 'SSO' },
              ]}
            />
          </GridList>
        </Form>
      </div>
      <Card>
        <Card.Content className="relative">
          <AuditLogList spaceId={space?.id} actorId={member?.id} noun={noun} />
        </Card.Content>
      </Card>
    </Container>
  )
}
